module.exports = __webpack_public_path__ + "img/25.a4e20e03.jpg";